// Old Android WebViews lack `Array`/`String.prototype.at` (Chrome 92 / ES2022).
export function polyfillAt(prototype: object): void {
  if ('at' in prototype) {
    return;
  }

  Object.defineProperty(prototype, 'at', {
    configurable: true,
    writable: true,
    value: function at(this: ArrayLike<unknown>, index: number): unknown {
      const relativeIndex = Math.trunc(index) || 0;
      const absoluteIndex =
        relativeIndex < 0 ? this.length + relativeIndex : relativeIndex;
      return absoluteIndex < 0 || absoluteIndex >= this.length
        ? undefined
        : this[absoluteIndex];
    },
  });
}

polyfillAt(Array.prototype);
polyfillAt(String.prototype);
